module.exports = "https://trybtryb-legacy.web.app/img/inayah.af29bdc6.webp";